import { CourseFee, Funding } from 'types';
import { FundingSummary } from '../../types';

export const getFundingContribution = (sponsorId: string, fundingSummary: FundingSummary): number => {
  let contributionAmount = 0;

  if (!sponsorId || !fundingSummary) {
    return contributionAmount;
  }

  // get the total contribution amount for the sponsor based on their ID
  const getFunding = (funding: Funding) => {
    if (sponsorId === funding.id) {
      contributionAmount += funding.amount;
    }
  };

  fundingSummary.studentLivingCost.funding.forEach(getFunding);
  fundingSummary.spouseLivingCost.funding.forEach(getFunding);
  fundingSummary.courseFees.forEach((course: CourseFee) => {
    course.funding.forEach(getFunding);
  });
  fundingSummary.childrenLivingCost.funding.forEach(getFunding);

  return contributionAmount;
};
